/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "antd-mobile";
import Theme from "../utils/Theme";
import * as _ from "underscore";

const StyledContainer = styled.div`
  width: 100%;
  min-height: 70vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
`;

const StyledImage = styled.img`
  width: 30%;
  height: auto;
`;

const StyledEmptyItemText = styled.span`
  margin-top: 15px;
  font-size: 1em;
`;

const RefreshButton = styled(Button)`
  width: 60%;
  align-self: center;
  margin-top: 35px;
  && {
    height: auto;
    line-height: unset;
    padding: 15px 0px;
    cursor: pointer;
    font-size: 1em !important;
    border-radius: 25px !important;
    color: white !important;
    background-color: ${Theme.PrimaryColor};
  }
`;

const AuthButton = styled(Button)`
  width: 60%;
  align-self: center;
  margin-top: 35px;
  && {
    height: auto;
    line-height: unset;
    padding: 15px 0px;
    cursor: pointer;
    font-size: 1em !important;
    border-radius: 25px !important;
    color: white !important;
    background-color: ${Theme.TertiaryColor};
  }
`;

class EmptyQueue extends Component {
  render() {
    const { onRefresh, onLogin, auth } = this.props;

    return (
      <StyledContainer>
        <StyledImage src={require("../assets/empty_queue_banner.png")} />
        <StyledEmptyItemText>
          <FormattedMessage id="app.no.queue" />
        </StyledEmptyItemText>
        {_.isEmpty(auth) ? (
          <AuthButton
            activeStyle={{ backgroundColor: Theme.ActiveTertiary }}
            onClick={() => onLogin && onLogin()}
          >
            <FormattedMessage id="auth.login.title" />
          </AuthButton>
        ) : (
          false
        )}
        {!_.isEmpty(auth) && onRefresh ? (
          <RefreshButton
            activeStyle={{ backgroundColor: Theme.ActivePrimary }}
            onClick={() => onRefresh && onRefresh()}
          >
            <FormattedMessage id="app.refresh" />
          </RefreshButton>
        ) : (
          false
        )}
      </StyledContainer>
    );
  }
}

EmptyQueue.propTypes = {
  auth: PropTypes.bool,
  onRefresh: PropTypes.func,
  onLogin: PropTypes.func
};

EmptyQueue.defaultProps = {};

export default EmptyQueue;



// WEBPACK FOOTER //
// ./src/components/EmptyQueue.js